import styled from "styled-components";

export const ModalContainer = styled.div`
  border-radius: 24px;
  border: 1px solid #18181b;
  background: #18181b;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 500px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px 0 16px;
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 6px;
`;

export const IconsContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const IconWrapper = styled.div`
  width: 24px;
  height: 24px;

  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.div`
  color: #fff;
  font-family: DM Sans;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.09px;
`;

export const TabsContainer = styled.div`
  height: 36px;
  border-radius: 100px;
  background: #3f3f46;
  margin-inline: 16px;
  display: flex;
  padding: 2px;
`;

export const Tab = styled.div`
  flex: 1;
  background: ${({ $selected }) => ($selected ? "white" : "transparent")};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 100px;
  opacity: ${({ $disabled }) => ($disabled ? 0.2 : 1)};
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  pointer-events: ${({ $disabled }) => $disabled && "none"};
`;

export const TabText = styled.p`
  color: ${({ $selected }) => ($selected ? "#18181B" : "white")};
  font-family: DM Sans;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.065px;
`;

export const Content = styled.div`
  padding: 0 16px;
`;

export const CategoryContainer = styled.div`
  display: flex;
  gap: 4px;
  padding: 0 16px 0 16px;
`;

export const CategoryItem = styled.div`
  display: flex;
  align-items: center;
  min-width: ${({ $width }) => $width && `${$width}px`};
  justify-content: center;
  height: 22px;

  padding: 2px 4px;

  background-color: ${({ $selected }) => ($selected ? "#3F3F46" : "#151517")};
  border-radius: 8px;
  border: 1px solid #3f3f46;

  cursor: pointer;
`;

export const CategoryText = styled.p`
  color: ${({ $selected }) => ($selected ? "#fff" : "#fff")};
  font-family: DM Sans;
  font-size: 12px;
  font-weight: ${({ $selected }) => ($selected ? "600" : "500")};
  letter-spacing: -0.07px;
`;
